define.alias("ember-math-helpers/helpers/exp", "settings/helpers/exp");